"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _course = babelHelpers.interopRequireDefault(require("./course"));

var _default = _course.default;
exports.default = _default;